/**
 * @file: 删除cube
 * @author: xiaolong.huang@dmall.com
 */

import { __delete__, __has__ } from './db';
import { findByCubeId, findParentCubeByCubeId } from './baseQuery';
import { findAllChildrenContainSelf } from './advanceQuery';

export function del(cubeId: CubeId): void {
    if (!__has__(cubeId)) {
        return;
    }

    let beRemovedCube: CubeNode = findByCubeId(cubeId);
    let parentCube: CubeNode = findParentCubeByCubeId(cubeId);
    let allChildren: Array<CubeId> = findAllChildrenContainSelf(cubeId);

    allChildren.forEach((delCube: CubeId): void => {
        let cube: CubeNode = findByCubeId(delCube);

        cube.destroy();
        __delete__(delCube);
    });

    if (!beRemovedCube || !parentCube) {
        return;
    }
    parentCube.remove(beRemovedCube);
}

export function delGroup(cubeIds: Array<CubeId>): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        del(cubeId);
    });
}
